import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { C, card, label } from "../lib/theme";

export default function Home() {
  const [home, setHome] = useState(null);
  useEffect(() => { api.home().then(setHome); }, []);
  if (!home) return <div style={{ color: C.faint }}>Loading…</div>;
  const cotw = home.contributor_of_the_week;
  return (
    <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1.4fr) minmax(280px,1fr)",
      gap: 16, alignItems: "start" }}>
      <div>
        <div style={label}>NEWS</div>
        {home.news.length === 0 && <div style={{ ...card, color: C.faint, fontSize: 12.5 }}>
          No announcements yet.</div>}
        {home.news.map((n) => (
          <div key={n.id} style={{ ...card, marginBottom: 12 }}>
            <div style={{ fontFamily: C.displayFont, fontSize: 20 }}>{n.title}</div>
            <p style={{ fontSize: 13, lineHeight: 1.65, color: C.dim, margin: "8px 0 0" }}>{n.body}</p>
          </div>
        ))}
      </div>
      <div>
        {cotw && (
          <div style={{ ...card, borderColor: C.brass, marginBottom: 14 }}>
            <div style={label}>CONTRIBUTOR OF THE WEEK</div>
            <div style={{ fontSize: 15, fontWeight: 600 }}>{cotw.display_name}
              {cotw.professional && <span style={{ color: C.brass }}> ✶</span>}</div>
            <div style={{ fontSize: 11, color: C.dim }}>
              {cotw.title.toUpperCase()} · {cotw.votes_this_week} worth-reading this week
            </div>
          </div>
        )}
        <div style={label}>BEST OF COMMUNITY</div>
        {home.best_of_community.length === 0 && (
          <div style={{ ...card, fontSize: 12.5, color: C.faint }}>
            Nothing has crossed the threshold this fortnight.</div>
        )}
        {home.best_of_community.map((p) => (
          <Link key={p.id} to={`/board/${p.id}`} style={{ textDecoration: "none", color: "inherit" }}>
            <div style={{ ...card, borderColor: C.brass, marginBottom: 12 }}>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>{p.title}</div>
              <div style={{ fontSize: 12.5, color: C.dim, marginBottom: 8 }}>{p.excerpt}…</div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5 }}>
                <span style={{ color: C.dim }}>{p.author}</span>
                <span style={{ color: C.brass }}>◆ {p.worth_reading}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
